import tippy from 'tippy.js';

const doTippy = () => {
	tippy('[data-tippy-content]', {
		theme: 'pricing'
	});
}

export default doTippy;